<template>
  <v-container fluid grid-list-md>
    <v-card class="mx-auto" >
      <v-card-text class="headline font-weight-bold">
        <v-card-actions class="headline font-weight-bold">
        Recebíveis
        <v-spacer></v-spacer>
        <div>
          Subtotal: {{ $n(subtotal, 'currency') }}
        </div>
        </v-card-actions>
        <v-card-actions>
          <v-list-tile class="grow">
            <v-layout align-center justify-end>
              <v-btn fab top right small @click="showFilters">
                <v-icon>filter_list</v-icon>
              </v-btn>
            </v-layout>
          </v-list-tile>
        </v-card-actions>
      </v-card-text>
      <deposit-table />
    </v-card>
    <deposit-filters />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { EventBus } from '@/services/event-bus';

export default {
  name: 'Deposits',
  computed: {
    ...mapGetters({
      subtotal: 'deposits/subtotal',
    }),
  },
  components: {
    DepositFilters: () => import('@/components/deposits/DepositFilters.vue'),
    DepositTable: () => import('@/components/deposits/DepositTable.vue'),
  },
  methods: {
    showFilters() {
      EventBus.$emit('layout.deposits.filters.show:true');
    },
  },
};
</script>
